import { render, staticRenderFns } from "./DisregardSegment.vue?vue&type=template&id=55857d4b&scoped=true"
import script from "./DisregardSegment.vue?vue&type=script&lang=js"
export * from "./DisregardSegment.vue?vue&type=script&lang=js"
import style0 from "./DisregardSegment.vue?vue&type=style&index=0&id=55857d4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55857d4b",
  null
  
)

export default component.exports